import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content-static/navigation-menu/help-centre/menu-blog-storage.webp")